import React from "react";
import { Col } from "@insightfulscience/atomic-react/Grid";

const GoogleRecaptchaNotice = props => (
	<Col shrink sx={{ fontSize: "xs", fontColor: "black--40" }} {...props}>
		Protected by reCAPTCHA (Google <a href="https://policies.google.com/privacy">Privacy Policy</a>{" "}
		and <a href="https://policies.google.com/terms">Terms of Service</a> apply)
	</Col>
);

export default GoogleRecaptchaNotice;
